/* 🤖 this file was generated by svg-to-ts */
export const matIconViewQuilt: {
  name: 'view-quilt';
  data: string;
} = {
  name: 'view-quilt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33v-4h3.33v4zM19 17h-3.33v-4H19v4zm0-6h-8.67V7H19v4z"/></svg>`
};
